import { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';
import { useAccountScope } from '../context/AccountScope';


function NewModulePage({
  module,
  vehicles = [],
  vehiculoSeleccionado = null,
  onClose
}) {
  const { id: accountId, fetch: scopedFetch } = useAccountScope();
  const user =
    JSON.parse(
      localStorage.getItem('user') || '{}'
    );
const videoRef = useRef(null);
const hlsRef = useRef(null);
const hlsRetryTimerRef = useRef(null);
const cameraAbortRef = useRef(null);
const cameraStartTimerRef = useRef(null);
const cameraRecoveryTimerRef = useRef(null);
const cameraRetryCountRef = useRef(0);
const cameraRequestRef = useRef(0);
const cameraBusyRef = useRef(false);

// Reproductor histórico independiente del video en vivo.
const recordingVideoRef = useRef(null);
const recordingHlsRef = useRef(null);
const recordingAbortRef = useRef(null);
const recordingRequestRef = useRef(0);
const activeRecordingRef = useRef(null);

const [activeCamera, setActiveCamera] = useState(null);
const [cameraLoading, setCameraLoading] = useState(false);
const [cameraPlaying, setCameraPlaying] = useState(false);
const [cameraRecovering, setCameraRecovering] = useState(false);
const [cameraPhase, setCameraPhase] = useState('');
const [cameraError, setCameraError] = useState('');
const [cameraState, setCameraState] = useState(null);

// MACCEZ_CAMERA_CAPABILITIES_V1
// Capacidades por modelo. Nunca por terminal, vehículo o usuario.
// Agregar nuevos modelos aquí no modifica el comportamiento de los existentes.
const cameraModel = String(
  cameraState?.camera?.model || ''
).trim();

const cameraModelKey = cameraModel.toUpperCase();

const cameraCapabilities = {
  live: Boolean(cameraState?.camera),
  recordings: Boolean(cameraState?.camera),

  // Confirmado/protocolizado para GD14.
  faceRecognition: false, // Temporal: pendiente de compatibilidad facial

  // Se mantienen ocultas hasta validación real en carretera.
  dms: false,
  adas: false,
  bsd: false
};


const [cameraLinkOpen, setCameraLinkOpen] = useState(false);
const [cameraIdentifier, setCameraIdentifier] = useState('');
const [verifiedCamera, setVerifiedCamera] = useState(null);
const [cameraVerifyLoading, setCameraVerifyLoading] = useState(false);
const [cameraLinkLoading, setCameraLinkLoading] = useState(false);
const [cameraLinkMessage, setCameraLinkMessage] = useState('');
// MACCEZ_RECORDINGS_UI_V1
const [recordingsOpen, setRecordingsOpen] = useState(false);
const [recordingsDate, setRecordingsDate] = useState(() => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
});
const [recordingsChannel, setRecordingsChannel] = useState(1);
const [recordingsLoading, setRecordingsLoading] = useState(false);
const [recordingsResult, setRecordingsResult] = useState(null);
const [recordingsError, setRecordingsError] = useState('');
const [recordingPlaying, setRecordingPlaying] = useState(false);
const [recordingLoading, setRecordingLoading] = useState(false);
const [recordingError, setRecordingError] = useState('');
const [activeRecording, setActiveRecording] = useState(null);
// DIVI_RECORDING_LIBRARY_V2: presentation-only filtering, no change to JT1078 catalog.
const [recordingSearch, setRecordingSearch] = useState('');
const [recordingHour, setRecordingHour] = useState('all');
const [recordingEventFilter, setRecordingEventFilter] = useState('all');
const [diviEventsTab, setDiviEventsTab] = useState('events');
const [diviEventKind, setDiviEventKind] = useState('all');
const [diviEventPriority, setDiviEventPriority] = useState('all');
const [recordingEventMatches, setRecordingEventMatches] = useState([]);
const [recordingEventsStatus, setRecordingEventsStatus] = useState('');
const [recordingOrder, setRecordingOrder] = useState('newest');
const [recordingExpanded, setRecordingExpanded] = useState(false);
const [recordingNow, setRecordingNow] = useState(0);
const [recordingLength, setRecordingLength] = useState(0);
const [recordingSeekBounds, setRecordingSeekBounds] = useState(null);
const [recordingSpeed, setRecordingSpeed] = useState(1);
const [recordingGeneration, setRecordingGeneration] = useState(null);
const [recordingDownloadBusy, setRecordingDownloadBusy] = useState(false);
const [recordingDownloadMessage, setRecordingDownloadMessage] = useState('');

// HLS historico: los rangos navegables cambian mientras llegan segmentos.
const updateRecordingSeekBounds = (video) => {
  if (!video) return;
  const ranges = video.seekable;
  if (!ranges || ranges.length === 0) {
    setRecordingSeekBounds(null);
    return;
  }
  let start = Infinity;
  let end = -Infinity;
  for (let i = 0; i < ranges.length; i++) {
    start = Math.min(start, ranges.start(i));
    end = Math.max(end, ranges.end(i));
  }
  if (Number.isFinite(start) && Number.isFinite(end) && end > start) {
    setRecordingSeekBounds({start, end});
  } else {
    setRecordingSeekBounds(null);
  }
};


// MACCEZ_GD14_DRIVER_UI_V1
const [driverOpen, setDriverOpen] = useState(false);
const [driverLoading, setDriverLoading] = useState(false);
const [driverError, setDriverError] = useState('');
const [driverEvents, setDriverEvents] = useState([]);
const [driverPhotos, setDriverPhotos] = useState({});
// MACCEZ_GD14_DRIVER_REGISTRY_UI_V2
const [registeredDrivers, setRegisteredDrivers] = useState([]);
const [driverRegistryLoading, setDriverRegistryLoading] = useState(false);
const [driverRegistryError, setDriverRegistryError] = useState('');
const [driverRegistryMessage, setDriverRegistryMessage] = useState('');
const [driverFormOpen, setDriverFormOpen] = useState(false);
const [driverName, setDriverName] = useState('');
const [driverCertificate, setDriverCertificate] = useState('');
const [driverPhoto, setDriverPhoto] = useState(null);
const [driverPhotoPreview, setDriverPhotoPreview] = useState('');




const vehicleId =
  vehiculoSeleccionado?.maccezVehicleId ||
  vehiculoSeleccionado?.id ||
  null;

const fetchCameraState = async () => {
  if (module !== 'camaras' || !vehicleId) {
    setCameraState(null);
    return;
  }

  try {
    const token = localStorage.getItem('token');

    const response = await scopedFetch(
      `/api/cameras/${vehicleId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const result = await response.json();

    if (!response.ok || !result.success) {
      throw new Error(
        result.message || 'CAMERA_STATE_ERROR'
      );
    }

    setCameraState(result);

    if (result.camera) {
      setVerifiedCamera(null);
      setCameraLinkOpen(false);
      setCameraLinkMessage('');
    }
  } catch (error) {
    console.error(
      'Error consultando cámara:',
      error
    );
  }
};

const verifyCamera = async () => {
  if (!vehicleId || !cameraIdentifier.trim()) return;

  try {
    setCameraVerifyLoading(true);
    setVerifiedCamera(null);
    setCameraLinkMessage('');

    const token = localStorage.getItem('token');

    const response = await scopedFetch(
      '/api/cameras/link/verify',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          vehicleId,
          identifier: cameraIdentifier.trim()
        })
      }
    );

    const result = await response.json();

    if (!response.ok || !result.success) {
      setCameraLinkMessage(
        result.message ||
        'No fue posible verificar la cámara.'
      );
      return;
    }

    setVerifiedCamera(result.camera);

  } catch (error) {
    console.error(
      'Error verificando cámara:',
      error
    );

    setCameraLinkMessage(
      'No fue posible verificar la cámara.'
    );
  } finally {
    setCameraVerifyLoading(false);
  }
};

const assignCamera = async () => {
  if (
    !vehicleId ||
    !verifiedCamera ||
    !cameraIdentifier.trim()
  ) return;

  try {
    setCameraLinkLoading(true);
    setCameraLinkMessage('');

    const token = localStorage.getItem('token');

    const response = await scopedFetch(
      '/api/cameras/link/assign',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          vehicleId,
          identifier: cameraIdentifier.trim()
        })
      }
    );

    const result = await response.json();

    if (!response.ok || !result.success) {
      setCameraLinkMessage(
        result.message ||
        'No fue posible vincular la cámara.'
      );
      return;
    }

    setCameraLinkMessage(
      'Cámara vinculada correctamente.'
    );

    await fetchCameraState();

  } catch (error) {
    console.error(
      'Error vinculando cámara:',
      error
    );

    setCameraLinkMessage(
      'No fue posible vincular la cámara.'
    );
  } finally {
    setCameraLinkLoading(false);
  }
};

useEffect(() => {
  if (module !== 'camaras' || !vehicleId) return;

  fetchCameraState();

  const interval = setInterval(() => {
    fetchCameraState();
  }, 2500);

  return () => clearInterval(interval);
}, [module, vehicleId, accountId]);

const clearRecordingPlayer = () => {
  recordingRequestRef.current += 1;

  if (recordingAbortRef.current) {
    recordingAbortRef.current.abort();
    recordingAbortRef.current = null;
  }

  if (recordingHlsRef.current) {
    recordingHlsRef.current.destroy();
    recordingHlsRef.current = null;
  }

  const video = recordingVideoRef.current;

  if (video) {
    video.pause();
    video.removeAttribute('src');
    video.load();
  }

  setRecordingPlaying(false);
  setRecordingLoading(false);
  setRecordingNow(0);
  setRecordingLength(0);
  setRecordingSeekBounds(null);
  setRecordingSpeed(1);
  setRecordingGeneration(null);
  setRecordingDownloadMessage('');
};

const stopRecordingPlayback = async ({
  silent = false
} = {}) => {
  const recording =
    activeRecordingRef.current ||
    activeRecording;

  clearRecordingPlayer();

  if (!vehicleId || !recording) {
    activeRecordingRef.current = null;
    setActiveRecording(null);
    return;
  }

  try {
    const token = localStorage.getItem('token');

    await scopedFetch(
      '/api/cameras/recordings/stop',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          vehicleId,
          channel: recording.channel
        })
      }
    );
  } catch (error) {
    if (!silent) {
      console.error(
        'Error deteniendo grabación:',
        error
      );
    }
  } finally {
    activeRecordingRef.current = null;
    setActiveRecording(null);
  }
};

const seekRecording = (seconds) => {
  const video = recordingVideoRef.current;
  if (!video || !Number.isFinite(seconds)) return;
  const ranges = video.seekable;
  if (!ranges || ranges.length === 0) {
    setRecordingError('La cámara todavía no permite saltar a ese punto.');
    return;
  }
  for (let i = 0; i < ranges.length; i++) {
    if (seconds >= ranges.start(i) && seconds <= ranges.end(i)) {
      video.currentTime = seconds;
      setRecordingError('');
      return;
    }
  }
  setRecordingError('Ese momento aún no está disponible en la transmisión.');
};

const skipRecording = (delta) => {
  const video = recordingVideoRef.current;
  if (video) seekRecording(video.currentTime + delta);
};

const playRecording = async (item) => {
  if (
    !vehicleId ||
    !item ||
    recordingLoading
  ) return;

  /*
   * Nunca mantenemos Live y playback histórico
   * transmitiendo simultáneamente.
   */
  cameraRequestRef.current += 1;
  cameraBusyRef.current = false;

  const token = localStorage.getItem('token');

  if (activeCamera) {
    try {
      await scopedFetch(
        '/api/cameras/stop',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            vehicleId
          })
        }
      );
    } catch (_error) {}

    clearCameraPlayer();
    setActiveCamera(null);
    setCameraPlaying(false);
    setCameraLoading(false);
    setCameraRecovering(false);
    setCameraPhase('');
  }

  /*
   * Si ya había otra grabación reproduciéndose,
   * la detenemos antes de iniciar la nueva.
   */
  if (activeRecording) {
    await stopRecordingPlayback({
      silent: true
    });
  }

  const requestId =
    ++recordingRequestRef.current;

  const abort =
    new AbortController();

  recordingAbortRef.current = abort;

  const isCurrent = () =>
    requestId === recordingRequestRef.current &&
    !abort.signal.aborted;

  setRecordingLoading(true);
  setRecordingPlaying(false);
  setRecordingError('');
  setRecordingGeneration(null);
  setRecordingDownloadMessage('');

  const selected = {
    ...item,
    channel: Number(item.channel) || recordingsChannel
  };

  activeRecordingRef.current = selected;
  setActiveRecording(selected);

  try {
    if (!token) {
      throw new Error(
        'Inicia sesión nuevamente para reproducir grabaciones.'
      );
    }

    const response = await scopedFetch(
      '/api/cameras/recordings/play',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          vehicleId,
          channel: selected.channel,
          start: item.start,
          end: item.end,
          resourceType: item.resourceType,
          streamType: item.streamType,
          memoryType: item.memoryType
        }),
        signal: abort.signal
      }
    );

    const result = await response.json();

    if (!isCurrent()) return;

    if (
      !response.ok ||
      !result.ok ||
      !result.streamUrl
    ) {
      throw new Error(
        result.error ||
        'No fue posible iniciar la grabación.'
      );
    }

    setRecordingGeneration(result.generation || null);
    const video = recordingVideoRef.current;
    video && (video.playbackRate = 1);

    if (!video) {
      throw new Error(
        'No se encontró el reproductor de grabaciones.'
      );
    }

    const play = () => {
      if (!isCurrent()) return;

      video.play().catch(error => {
        if (isCurrent()) {
          console.warn(
            'Reproducción histórica:',
            error.message
          );
        }
      });
    };

    video.addEventListener(
      'playing',
      () => {
        if (!isCurrent()) return;

        setRecordingPlaying(true);
        setRecordingLoading(false);
      },
      {
        signal: abort.signal
      }
    );

    if (
      video.canPlayType(
        'application/vnd.apple.mpegurl'
      )
    ) {
      video.src = result.streamUrl;
      video.load();
      play();

    } else if (Hls.isSupported()) {
      const hls = new Hls({
        enableWorker: true,
        lowLatencyMode: false,
        maxBufferLength: 60,
        // El historico no debe descartar rapidamente lo ya reproducido:
        // habilita regresar por la misma sesion mientras sigue disponible.
        backBufferLength: 240,

        // El HLS histórico está protegido por authMiddleware.
        // El token del stream identifica el recurso, mientras que
        // Authorization mantiene autenticada la sesión del usuario
        // para manifest y segmentos.
        xhrSetup: (xhr) => {
          xhr.setRequestHeader(
            'Authorization',
            `Bearer ${token}`
          );
        }
      });

      recordingHlsRef.current = hls;

      hls.on(
        Hls.Events.MANIFEST_PARSED,
        play
      );

      hls.on(
        Hls.Events.ERROR,
        (_event, data) => {
          if (
            !isCurrent() ||
            recordingHlsRef.current !== hls
          ) return;

          if (data.fatal) {
            console.error(
              'Error HLS histórico:',
              data.type,
              data.details
            );

            setRecordingError(
              'Se interrumpió la reproducción.'
            );

            setRecordingLoading(false);
          }
        }
      );

      hls.attachMedia(video);
      hls.loadSource(result.streamUrl);

    } else {
      throw new Error(
        'Este dispositivo no admite reproducción HLS.'
      );
    }

  } catch (error) {
    if (!isCurrent()) return;

    console.error(
      'Error reproduciendo grabación:',
      error
    );

    setRecordingError(
      error.message ||
      'No fue posible reproducir la grabación.'
    );

    setRecordingLoading(false);
    setRecordingPlaying(false);

    /*
     * Si 0x9201 alcanzó a iniciarse pero el frontend
     * falló después, detenemos explícitamente.
     */
    try {
      await scopedFetch(
        '/api/cameras/recordings/stop',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            vehicleId,
            channel: selected.channel
          })
        }
      );
    } catch (_stopError) {}
  }
};


// Sólo exporta los segmentos históricos que la GD14 ya terminó de transmitir.
const downloadRecording = async () => {
  if (!recordingGeneration || !activeRecording || recordingDownloadBusy || !vehicleId) return;
  const token = localStorage.getItem('token');
  if (!token) { setRecordingDownloadMessage('Inicia sesión nuevamente.'); return; }
  setRecordingDownloadBusy(true);
  setRecordingDownloadMessage('Preparando MP4 del video recibido…');
  try {
    const response = await scopedFetch('/api/cameras/recordings/export', {
      method:'POST',
      headers:{'Content-Type':'application/json',Authorization:`Bearer ${token}`},
      body:JSON.stringify({vehicleId,channel:activeRecording.channel,generation:recordingGeneration})
    });
    if (!response.ok) {
      const json = await response.json().catch(() => ({}));
      if (response.status === 409) throw new Error('La transmisión aún está terminando. Espera a que finalice y vuelve a descargar.');
      if (response.status === 404) throw new Error('El clip temporal expiró. Reprodúcelo nuevamente.');
      if (response.status === 413) throw new Error('El clip supera el límite de exportación.');
      throw new Error(json.error || 'No se pudo exportar el clip.');
    }
    const blob = await response.blob();
    if (!blob.size) throw new Error('El archivo descargado está vacío.');
    const url = URL.createObjectURL(blob);
    const filename = `DIVI-${vehicleId}-cam${activeRecording.channel}-${recordingGeneration}.mp4`;
    try {
      if (typeof navigator.share === 'function' &&
          typeof navigator.canShare === 'function') {
        const file = new File([blob], filename, {type:'video/mp4'});
        if (navigator.canShare({files:[file]})) {
          try { await navigator.share({files:[file],title:'Videoclip DIVI'}); setRecordingDownloadMessage('Video listo para guardar o compartir.'); return; }
          catch (error) { if (error.name === 'AbortError') { setRecordingDownloadMessage('No se guardó el video.'); return; } }
        }
      }
      const a = document.createElement('a'); a.href=url; a.download=filename;
      document.body.appendChild(a); a.click(); a.remove();
      setRecordingDownloadMessage('Descarga del MP4 iniciada.');
    } finally { setTimeout(() => URL.revokeObjectURL(url), 60000); }
  } catch (error) { setRecordingDownloadMessage(error.message || 'No se pudo descargar el video.'); }
  finally { setRecordingDownloadBusy(false); }
};


const clearDriverPhotos = () => {
  setDriverPhotos((current) => {
    Object.values(current).forEach((url) => {
      if (
        typeof url === 'string' &&
        url.startsWith('blob:')
      ) {
        URL.revokeObjectURL(url);
      }
    });

    return {};
  });
};

const loadDriverPhoto = async (eventId) => {
  if (!vehicleId || !eventId) return;

  try {
    const token = localStorage.getItem('token');

    if (!token) return;

    const response = await scopedFetch(
      `/api/cameras/${vehicleId}/face-events/${eventId}/photo`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!response.ok) return;

    const blob = await response.blob();

    if (!blob.size) return;

    const url = URL.createObjectURL(blob);

    setDriverPhotos((current) => {
      const previous = current[eventId];

      if (
        previous &&
        previous.startsWith('blob:')
      ) {
        URL.revokeObjectURL(previous);
      }

      return {
        ...current,
        [eventId]: url
      };
    });
  } catch (error) {
    console.warn(
      'No fue posible cargar foto de conductor:',
      error.message
    );
  }
};

const clearDriverForm = () => {
  if (driverPhotoPreview?.startsWith('blob:')) URL.revokeObjectURL(driverPhotoPreview);
  setDriverName('');
  setDriverCertificate('');
  setDriverPhoto(null);
  setDriverPhotoPreview('');
};

const queryRegisteredDrivers = async () => {
  if (!vehicleId || !cameraCapabilities.faceRecognition) return;
  setDriverRegistryLoading(true);
  setDriverRegistryError('');
  try {
    const token = localStorage.getItem('token');
    const response = await scopedFetch(`/api/cameras/${vehicleId}/face-drivers`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const result = await response.json();
    if (!response.ok || !result.success) throw new Error(result.message || result.error || 'No fue posible consultar los conductores.');
    setRegisteredDrivers(Array.isArray(result.drivers) ? result.drivers : []);
  } catch (error) {
    setDriverRegistryError(error.message || 'No fue posible consultar los conductores.');
  } finally {
    setDriverRegistryLoading(false);
  }
};

const registerFaceDriver = async (event) => {
  event.preventDefault();
  if (!driverName.trim() || !driverPhoto || driverRegistryLoading) return;
  setDriverRegistryLoading(true);
  setDriverRegistryError('');
  setDriverRegistryMessage('Enviando el conductor a la cámara…');
  try {
    const token = localStorage.getItem('token');
    const form = new FormData();
    form.append('name', driverName.trim());
    if (driverCertificate.trim()) form.append('certificate', driverCertificate.trim());
    form.append('photo', driverPhoto, driverPhoto.name || 'conductor.jpg');
    const response = await scopedFetch(`/api/cameras/${vehicleId}/face-drivers`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: form
    });
    const result = await response.json();
    if (!response.ok || !result.success) throw new Error(result.error || result.message || 'No fue posible sincronizar el conductor.');
    setDriverRegistryMessage('✓ Conductor sincronizado con la cámara.');
    clearDriverForm();
    setDriverFormOpen(false);
    await queryRegisteredDrivers();
  } catch (error) {
    setDriverRegistryMessage('');
    setDriverRegistryError(error.message || 'No fue posible sincronizar el conductor.');
    await queryRegisteredDrivers();
  } finally {
    setDriverRegistryLoading(false);
  }
};

const retryFaceDriverSync = async (driverId) => {
  if (driverRegistryLoading) return;
  setDriverRegistryLoading(true);
  setDriverRegistryError('');
  setDriverRegistryMessage('Reintentando sincronización…');
  try {
    const token = localStorage.getItem('token');
    const response = await scopedFetch(`/api/cameras/${vehicleId}/face-drivers/${driverId}/sync`, {
      method: 'POST', headers: { Authorization: `Bearer ${token}` }
    });
    const result = await response.json();
    if (!response.ok || !result.success) throw new Error(result.error || 'No fue posible sincronizar.');
    setDriverRegistryMessage('✓ Conductor sincronizado con la cámara.');
    await queryRegisteredDrivers();
  } catch (error) {
    setDriverRegistryMessage('');
    setDriverRegistryError(error.message || 'No fue posible sincronizar.');
    await queryRegisteredDrivers();
  } finally {
    setDriverRegistryLoading(false);
  }
};

const queryDriverEvents = async () => {
  if (
    !vehicleId ||
    !cameraState?.camera ||
    !cameraCapabilities.faceRecognition ||
    driverLoading
  ) {
    return;
  }

  setDriverLoading(true);
  setDriverError('');

  try {
    const token = localStorage.getItem('token');

    if (!token) {
      throw new Error(
        'Inicia sesión nuevamente para consultar conductores.'
      );
    }

    const response = await scopedFetch(
      `/api/cameras/${vehicleId}/face-events?limit=20`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const result = await response.json();

    if (!response.ok || !result.success) {
      throw new Error(
        result.message ||
        'No fue posible consultar las identificaciones.'
      );
    }

    const events = Array.isArray(result.events)
      ? result.events
      : [];

    clearDriverPhotos();
    setDriverEvents(events);

    // Cargamos únicamente las fotos que el backend indica.
    // Un fallo de una foto no invalida el historial.
    events
      .filter((event) => event.photoUrl)
      .slice(0, 10)
      .forEach((event) => {
        void loadDriverPhoto(event.id);
      });

  } catch (error) {
    console.error(
      'Error consultando reconocimiento facial:',
      error
    );

    setDriverError(
      error.message ||
      'No fue posible consultar las identificaciones.'
    );
  } finally {
    setDriverLoading(false);
  }
};

const queryRecordings = async () => {
  if (!vehicleId || !cameraState?.camera || !recordingsDate || recordingsLoading) return;
  setRecordingsLoading(true);
  setRecordingsError('');
  setRecordingsResult(null);
  try {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('Inicia sesión nuevamente para consultar grabaciones.');
    // Consultar ambos canales en secuencia: el signaling mantiene una sola
    // operación pendiente 0x1205 por terminal y las consultas paralelas chocan.
    const channels = recordingsChannel === 0 ? [1, 2] : [recordingsChannel];
    const collected = [];
    const failures = [];
    for (const channel of channels) {
      try {
        const response = await scopedFetch('/api/cameras/recordings/query', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            vehicleId, channel,
            start: `${recordingsDate} 00:00:00`,
            end: `${recordingsDate} 23:59:59`
          })
        });
        const result = await response.json();
        if (!response.ok || !result.ok) throw new Error(result.error || `HTTP ${response.status}`);
        collected.push(...(result.items || []).map(item => ({...item, channel})));
      } catch (error) {
        failures.push(`${channel === 1 ? 'Frontal' : 'Interior'}: ${error.message}`);
      }
    }
    if (failures.length && !collected.length) throw new Error(failures.join(' · '));
    if (failures.length) setRecordingsError(`Consulta parcial: ${failures.join(' · ')}`);
    setRecordingsResult({ok: true, items: collected});
    // Consultar eventos existentes, sin mezclar su origen con el catálogo SD.
    setRecordingEventMatches([]);
    setRecordingEventsStatus('Consultando alertas registradas…');
    try {
      const params = new URLSearchParams({
        vehicleId: String(vehicleId),
        startDate: `${recordingsDate} 00:00:00`,
        endDate: `${recordingsDate} 23:59:59`,
        limit: '500',
        source: 'greatwill_ai'
      });
      const eventResponse = await scopedFetch(`/api/events?${params}`, {
        headers: {Authorization: `Bearer ${token}`}
      });
      const eventResult = await eventResponse.json();
      if (!eventResponse.ok || !eventResult.success) throw new Error('EVENTS_UNAVAILABLE');
      setRecordingEventMatches((Array.isArray(eventResult.events) ? eventResult.events : []).filter(isGreatWillCameraAIEvent));
      setRecordingEventsStatus((eventResult.events || []).length >= 500
        ? 'Se consultaron los 500 eventos más recientes; puede haber eventos anteriores no incluidos.' : '');
    } catch (error) {
      setRecordingEventsStatus('No fue posible consultar las alertas; las grabaciones siguen disponibles.');
    }
  } catch (error) {
    setRecordingsError(error.message || 'No fue posible consultar las grabaciones.');
  } finally {
    setRecordingsLoading(false);
  }
};

useEffect(() => {
  setRecordingsResult(null);
  setRecordingsError('');
  setRecordingEventMatches([]);
  setRecordingEventsStatus('');
  setRecordingsOpen(false);

  // MACCEZ_GD14_DRIVER_UI_V1
  setDriverOpen(false);
  setDriverEvents([]);
  setDriverError('');
  setRegisteredDrivers([]);
  setDriverRegistryError('');
  setDriverRegistryMessage('');
  setDriverFormOpen(false);
  clearDriverForm();
  clearDriverPhotos();
}, [vehicleId, accountId, module]);

// One switch owns its abort signal, HLS instance and retry timers.
const clearCameraPlayer = () => {
  if (cameraAbortRef.current) {
    cameraAbortRef.current.abort();
    cameraAbortRef.current = null;
  }
  for (const ref of [hlsRetryTimerRef, cameraStartTimerRef, cameraRecoveryTimerRef]) {
    if (ref.current) clearTimeout(ref.current);
    ref.current = null;
  }
  if (hlsRef.current) {
    hlsRef.current.destroy();
    hlsRef.current = null;
  }
  const video = videoRef.current;
  if (video) {
    video.pause();
    video.removeAttribute('src');
    video.load();
  }
};

const selectCamera = async (channel) => {
  if (!vehicleId || !cameraState?.camera) return;

  // MACCEZ_RECORDING_CLEANUP_V1
  // Nunca mantener playback histórico y Live simultáneamente.
  if (activeRecording) {
    await stopRecordingPlayback({
      silent: true
    });
  }

  cameraBusyRef.current = true;
  const requestId = ++cameraRequestRef.current;
  const abort = new AbortController();
  const isCurrent = () =>
    requestId === cameraRequestRef.current && !abort.signal.aborted;
  const sleep = (ms) => new Promise((resolve) => {
    const timer = setTimeout(resolve, ms);
    abort.signal.addEventListener('abort', () => {
      clearTimeout(timer);
      resolve();
    }, { once: true });
  });
  const finishLoading = () => {
    if (isCurrent()) {
      cameraBusyRef.current = false;
      setCameraLoading(false);
    }
  };

  clearCameraPlayer();
  cameraAbortRef.current = abort;
  cameraRetryCountRef.current = 0;
  setCameraError('');
  setCameraPlaying(false);
  setCameraRecovering(false);
  setCameraPhase('Solicitando transmisión…');
  setCameraLoading(true);
  setActiveCamera(channel);

  try {
    const token = localStorage.getItem('token');
    const response = await scopedFetch('/api/cameras/live', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ vehicleId, channel }),
      signal: abort.signal
    });
    const result = await response.json();
    if (!isCurrent()) return;
    if (!response.ok || !result.ok || !result.streamUrl) {
      throw new Error(result.error || 'No fue posible iniciar el canal.');
    }

    setCameraPhase('Preparando video en vivo…');
    // Wait for a CURRENT, complete manifest and its first segment.
    // A 404 during the 9102 -> 9101 transition is expected, not a fatal error.
    let ready = false;
    for (let attempt = 0; attempt < 80 && isCurrent(); attempt += 1) {
      try {
        const playlistResponse = await fetch(result.streamUrl, {
          cache: 'no-store', signal: abort.signal
        });
        if (playlistResponse.ok) {
          const playlist = await playlistResponse.text();
          const segments = playlist.split(/\r?\n/).map(x => x.trim())
            .filter(x => x && !x.startsWith('#'));
          if (playlist.startsWith('#EXTM3U') && segments.length) {
            ready = true;
            break;
          }
        } else if ([401, 403].includes(playlistResponse.status)) {
          throw new Error('La autorización del video expiró.');
        }
      } catch (error) {
        if (!isCurrent()) return;
        if (error.message === 'La autorización del video expiró.') throw error;
      }
      await sleep(500);
    }
    if (!isCurrent()) return;
    if (!ready) throw new Error('La cámara no entregó video a tiempo.');

    setCameraPhase('Iniciando reproducción…');
    const video = videoRef.current;
    if (!video) throw new Error('No se encontró el reproductor.');
    const play = () => {
      if (!isCurrent()) return;
      video.play().catch((error) => {
        if (isCurrent()) console.warn('Reproducción de cámara:', error.message);
      });
    };
    const onPlaying = () => {
      if (!isCurrent()) return;
      if (cameraRecoveryTimerRef.current) {
        clearTimeout(cameraRecoveryTimerRef.current);
        cameraRecoveryTimerRef.current = null;
      }
      cameraRetryCountRef.current = 0;
      setCameraPlaying(true);
      setCameraRecovering(false);
      setCameraPhase('');
      finishLoading();
    };
    const onWaiting = () => {
      if (!isCurrent() || cameraRecoveryTimerRef.current) return;

      // A short mobile-network jitter is normal. Keep the last frame visible
      // and recover silently; only tell the driver after a sustained stall.
      cameraRecoveryTimerRef.current = setTimeout(() => {
        cameraRecoveryTimerRef.current = null;
        if (!isCurrent() || !video.paused && video.readyState >= 3) return;
        setCameraRecovering(true);
        setCameraPhase('Retomando video…');
      }, 3500);
    };
    video.addEventListener('waiting', onWaiting, { signal: abort.signal });
    video.addEventListener('stalled', onWaiting, { signal: abort.signal });
    video.addEventListener('playing', onPlaying, { signal: abort.signal });

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = result.streamUrl;
      video.load();
      play();
      video.addEventListener('error', () => {
        if (!isCurrent()) return;
        // Native HLS recovery: reload the current source, never resend 9101.
        if (cameraRetryCountRef.current++ >= 8) {
          setCameraError('No se pudo recuperar el video. Selecciona la cámara nuevamente.');
          finishLoading();
          return;
        }
        cameraStartTimerRef.current = setTimeout(() => {
          if (isCurrent()) { video.load(); play(); }
        }, 2000);
      }, { signal: abort.signal });
    } else if (Hls.isSupported()) {
      const hls = new Hls({
        enableWorker: true,
        lowLatencyMode: false,
        maxBufferLength: 30,
        backBufferLength: 30,
        maxBufferHole: 0.8,
        manifestLoadingMaxRetry: 4,
        levelLoadingMaxRetry: 4,
        fragLoadingMaxRetry: 4
      });
      hlsRef.current = hls;
      hls.on(Hls.Events.MANIFEST_PARSED, play);
      hls.on(Hls.Events.ERROR, (_event, data) => {
        if (!isCurrent() || hlsRef.current !== hls || !data.fatal) return;
        console.warn('Error HLS:', data.type, data.details);
        if (cameraRetryCountRef.current++ >= 12) {
          setCameraError('Se interrumpió el video. Selecciona la cámara para reconectar.');
          finishLoading();
          hls.destroy();
          if (hlsRef.current === hls) hlsRef.current = null;
          return;
        }
        if (hlsRetryTimerRef.current) return;
        hlsRetryTimerRef.current = setTimeout(() => {
          hlsRetryTimerRef.current = null;
          if (!isCurrent() || hlsRef.current !== hls) return;
          if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
            hls.recoverMediaError();
          } else if (data.details === Hls.ErrorDetails.MANIFEST_LOAD_ERROR ||
                     data.details === Hls.ErrorDetails.MANIFEST_LOAD_TIMEOUT ||
                     data.details === Hls.ErrorDetails.LEVEL_LOAD_ERROR ||
                     data.details === Hls.ErrorDetails.LEVEL_LOAD_TIMEOUT) {
            hls.loadSource(result.streamUrl);
          } else {
            hls.startLoad();
          }
        }, 2000);
      });
      hls.attachMedia(video);
      hls.loadSource(result.streamUrl);
    } else {
      throw new Error('Este navegador no admite HLS.');
    }
    // Keep the loading indicator until the browser fires `playing`.
    cameraStartTimerRef.current = setTimeout(() => {
      if (isCurrent() && video.paused) {
        setCameraError('El video está listo, pero no inició. Pulsa Play.');
        finishLoading();
      }
    }, 15000);
  } catch (error) {
    if (isCurrent()) {
      console.error('Error cambiando cámara:', error);
      setCameraError(error.message || 'Error iniciando cámara.');
      setCameraPlaying(false);
      finishLoading();
    }
  } finally {
    // Unlock switching after the command and initial readiness check.
    // Playback errors continue to be handled by the current HLS session.
    if (isCurrent()) cameraBusyRef.current = false;
  }
};

useEffect(() => {
  if (module !== 'camaras') return;

  return () => {
    cameraRequestRef.current += 1;
    cameraBusyRef.current = false;

    const token = localStorage.getItem('token');

    if (vehicleId) {
      window.fetch(
        '/api/cameras/stop',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-Monitor-User-Id': String(accountId)
          },
          body: JSON.stringify({
            vehicleId
          }),
          keepalive: true
        }
      ).catch(() => {});
    }

    clearCameraPlayer();

    // Si había reproducción histórica, enviar 0x9202
    // inmediatamente. El watchdog queda solo como respaldo.
    const recording =
      activeRecordingRef.current;

    if (vehicleId && recording?.channel) {
      window.fetch(
        '/api/cameras/recordings/stop',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-Monitor-User-Id': String(accountId)
          },
          body: JSON.stringify({
            vehicleId,
            channel: recording.channel
          }),
          keepalive: true
        }
      ).catch(() => {});
    }

    activeRecordingRef.current = null;
    clearRecordingPlayer();
  };
}, [
  module,
  vehicleId,
  accountId
]);
  const online =
    vehicles.filter(
      (vehicle) =>
        vehicle.connectionStatus ===
        'ONLINE'
    ).length;

  const modules = {
    camaras: {
      eyebrow: 'Seguridad visual',
      title: 'Cámaras',
      description:
        'Video en vivo, evidencia por eventos e identificación del conductor.',
      items: [
        'Video en vivo',
        'Clips por evento',
        'Identificación del conductor'
      ]
    },

    control: {
      eyebrow: 'Acciones remotas',
      title: 'Control',
      description:
        'Control seguro de salidas y autorización de acceso al vehículo.',
      items: [
        'Control del motor',
        'Control de puertas',
        'Alerta sonora',
        'Acceso autorizado'
      ]
    },

    cuenta: {
      eyebrow: 'Perfil y servicio',
      title: 'Mi Cuenta',
      description:
        user.name ||
        'Información del usuario',
      items: [
        user.email || 'Correo no registrado',
        `Rol: ${user.role || 'usuario'}`,
        `Activos asignados: ${vehicles.length}`,
        `Activos online: ${online}`
      ]
    }
  };

  const current =
    modules[module] ||
    modules.cuenta;

  const recordingItems = Array.isArray(recordingsResult?.items) ? recordingsResult.items : [];
  // Correlación por intervalo horario: no equivale a un clip disparado por evento.
  const enrichedRecordings = recordingItems.map((item) => {
    const startMs = parseRecordingTimestamp(item.start);
    const endMs = parseRecordingTimestamp(item.end);
    const matchedEvents = recordingEventMatches.filter((event) => {
      const when = parseRecordingTimestamp(event.created_at);
      const preferredChannel = diviEventChannel(event);
      return Number.isFinite(startMs) && Number.isFinite(endMs) &&
        Number.isFinite(when) && when >= startMs && when <= endMs &&
        (preferredChannel === null || preferredChannel === Number(item.channel));
    });
    const tags = [...new Set(matchedEvents.map(event => recordingEventCategory(event)))];
    return {...item, matchedEvents, eventTags: tags};
  });
  // Only show category choices with a real overlapping event, never empty promises.
  // Únicamente alarmas de IA generadas por Great-Will. Nunca Teltonika/ACC.
  const recordingEventChoices = [
    {value: 'alerts', label: 'Alarmas de cámara', test: item => item.matchedEvents.length > 0},
    {value: 'ADAS', label: 'ADAS · Carretera', test: item => item.eventTags.includes('ADAS')},
    {value: 'DMS', label: 'DMS · Conductor', test: item => item.eventTags.includes('DMS')},
    ...[...new Set(recordingEventMatches.map(diviEventKindOf))].sort().map(kind => ({
      value: `camera:${kind}`, label: kind,
      test: item => item.matchedEvents.some(event => diviEventKindOf(event) === kind)
    })),
    {value: 'none', label: 'Sin alarma IA de cámara vinculada', test: item => item.eventTags.length === 0}
  ].map(choice => ({...choice, count: enrichedRecordings.filter(choice.test).length}));
  const diviEventKinds = [...new Set(recordingEventMatches.map(diviEventKindOf))].sort();
  const diviFilteredEvents = recordingEventMatches.filter(event =>
    (diviEventKind === 'all' || diviEventKindOf(event) === diviEventKind) &&
    (diviEventPriority === 'all' || String(event.event_level).toLowerCase() === diviEventPriority)
  );
  const recordingAllEvents = recordingEventMatches.slice(0, 40);
  const visibleRecordings = enrichedRecordings
    .filter(item => recordingHour === 'all' || recordingTime(item.start).slice(0, 2) === recordingHour)
    .filter(item => recordingEventFilter === 'all' ||
      (recordingEventFilter === 'none' && !item.eventTags.length) ||
      (recordingEventFilter === 'alerts' && item.matchedEvents.some(event =>
        ['warning','critical'].includes(String(event.event_level).toLowerCase()))) ||
      (recordingEventFilter.startsWith('camera:') && item.matchedEvents.some(event => diviEventKindOf(event) === recordingEventFilter.slice(7))) ||
      item.eventTags.includes(recordingEventFilter))
    .filter(item => !recordingSearch.trim() ||
      `${item.start} ${item.end} ${item.eventTags.join(' ')} ${item.matchedEvents.map(e => e.title || '').join(' ')}`
        .toLowerCase().includes(recordingSearch.trim().toLowerCase()))
    .slice()
    .sort((a,b) => recordingOrder === 'newest'
      ? String(b.start).localeCompare(String(a.start))
      : String(a.start).localeCompare(String(b.start)));
  const recordingGroups = visibleRecordings.reduce((groups,item) => {
    const h = recordingTime(item.start).slice(0,2);
    const label = /^\d{2}$/.test(h) ? `${h}:00 – ${h}:59` : 'Sin horario';
    if (!groups[label]) groups[label] = [];
    groups[label].push(item);
    return groups;
  }, {});

  return (
    <section style={styles.wrapper}>
      <div style={styles.header}>
        <div>
          <div style={styles.eyebrow}>
            {current.eyebrow}
          </div>

          <h1 style={styles.title}>
            {current.title}
          </h1>
        </div>

        <button
          type="button"
          onClick={onClose}
          aria-label="Cerrar"
          style={styles.closeButton}
        >
          ×
        </button>
      </div>

      <p style={styles.description}>
        {current.description}
      </p>
{module === 'camaras' && (
  <>
    <div style={styles.linkCard}>
      {!vehicleId ? (
        <>
          <div style={styles.linkTitle}>
            Cámaras
          </div>

          <div style={styles.linkSubtitle}>
            Selecciona un activo
          </div>

          <div style={styles.linkText}>
            Selecciona un vehículo antes de administrar sus cámaras.
          </div>
        </>
      ) : cameraState?.camera ? (
        <>
          <div style={styles.linkTitle}>
            Cámaras
          </div>

          <div style={styles.linkSuccess}>
            ✓ Cámara vinculada
          </div>

          <div style={styles.linkText}>
            {cameraState.camera.model || 'Cámara'} · {cameraState.camera.terminal_id}
          </div>
        </>
      ) : (
        <>
          {!cameraLinkOpen ? (
            <>
              <div style={styles.linkTitle}>
                Cámaras
              </div>

              <div style={styles.linkSubtitle}>
                Consulta por tu cámara
              </div>

              <div style={styles.linkText}>
                Agrega seguridad visual y reconocimiento de conductor a este vehículo.
              </div>

              <button
                type="button"
                onClick={() => {
                  setCameraLinkOpen(true);
                  setVerifiedCamera(null);
                  setCameraLinkMessage('');
                }}
                style={styles.linkButton}
              >
                Vincular cámara
              </button>
            </>
          ) : (
            <>
              <div style={styles.linkTitle}>
                Vincular cámara
              </div>

              <div style={styles.linkText}>
                Escribe el ID o IMEI de la cámara.
              </div>

              <input
                type="text"
                value={cameraIdentifier}
                onChange={(event) => {
                  setCameraIdentifier(
                    event.target.value
                  );
                  setVerifiedCamera(null);
                  setCameraLinkMessage('');
                }}
                placeholder="ID o IMEI"
                autoComplete="off"
                inputMode="text"
                style={styles.cameraIdInput}
              />

              {!verifiedCamera && (
                <button
                  type="button"
                  onClick={verifyCamera}
                  disabled={
                    cameraVerifyLoading ||
                    !cameraIdentifier.trim()
                  }
                  style={styles.linkButton}
                >
                  {cameraVerifyLoading
                    ? 'Verificando...'
                    : 'Verificar cámara'}
                </button>
              )}

              {verifiedCamera && (
                <div style={styles.verifiedCamera}>
                  <div style={styles.verifiedCameraTitle}>
                    {verifiedCamera.model || 'Cámara'} detectada
                  </div>

                  <div style={styles.cameraOnline}>
                    ● En línea
                  </div>

                  <div style={styles.verifiedCameraId}>
                    ID: {verifiedCamera.terminalId}
                  </div>

                  <button
                    type="button"
                    onClick={assignCamera}
                    disabled={cameraLinkLoading}
                    style={styles.linkButton}
                  >
                    {cameraLinkLoading
                      ? 'Vinculando...'
                      : 'Vincular cámara'}
                  </button>
                </div>
              )}

              {cameraLinkMessage && (
                <div style={styles.cameraLinkMessage}>
                  {cameraLinkMessage}
                </div>
              )}

              <button
                type="button"
                onClick={() => {
                  setCameraLinkOpen(false);
                  setVerifiedCamera(null);
                  setCameraIdentifier('');
                  setCameraLinkMessage('');
                }}
                style={styles.cancelLinkButton}
              >
                Cancelar
              </button>
            </>
          )}
        </>
      )}
    </div>

  <div style={styles.videoCard}>
    <div style={styles.cameraSelector}>
      <button
        type="button"
        onClick={() => selectCamera(1)}
        disabled={
          !cameraState?.camera
        }
        style={{
          ...styles.cameraButton,
          ...(activeCamera === 1
            ? styles.cameraButtonActive
            : {})
        }}
      >
        Frontal
      </button>

      <button
        type="button"
        onClick={() => selectCamera(2)}
        disabled={
          !cameraState?.camera
        }
        style={{
          ...styles.cameraButton,
          ...(activeCamera === 2
            ? styles.cameraButtonActive
            : {})
        }}
      >
        Interior
      </button>
    </div>

    <style>{'@keyframes gd301Spin { to { transform: rotate(360deg); } }'}</style>
    <div style={styles.videoStage}>
      <video
        ref={videoRef}
        controls={!cameraLoading}
        autoPlay
        muted
        playsInline
        style={styles.video}
      />
      {cameraLoading && !cameraPlaying && !cameraError && (
        <div style={styles.videoLoadingOverlay} role="status" aria-live="polite">
          <div style={styles.videoLoadingSpinner} />
          <strong style={styles.videoLoadingTitle}>
            {activeCamera === 1 ? 'Cámara frontal' : activeCamera === 2 ? 'Cámara interior' : 'Cámara'}
          </strong>
          <span style={styles.videoLoadingText}>{cameraPhase || 'Conectando…'}</span>
          <span style={styles.videoLoadingHint}>La transmisión se iniciará automáticamente</span>
        </div>
      )}
      {cameraRecovering && cameraPlaying && !cameraError && (
        <div style={styles.videoRecoveryBadge} role="status" aria-live="polite">
          <div style={styles.videoRecoverySpinner} />
          <span>Retomando video…</span>
        </div>
      )}
    </div>

    <div style={styles.videoInfo}>
      <strong>
      {activeCamera === 1
  ? `${cameraModel || 'Cámara'} · Cámara frontal`
  : activeCamera === 2
  ? `${cameraModel || 'Cámara'} · Cámara interior`
  : `${cameraModel || 'Cámara'} · Selecciona una cámara`}
  
      </strong>

      {cameraError && <span role="alert">{cameraError}</span>}
      <span>
        {cameraRecovering
          ? 'Retomando video…'
          : cameraLoading
          ? (cameraPhase || 'Conectando…')
          : cameraPlaying
          ? '● Video en vivo'
          : activeCamera
          ? 'Video detenido'
          : 'En espera'}
      </span>
    </div>
  </div>
  {vehicleId && cameraState?.camera && (
    <div style={styles.recordingsCard}>
      <button
        type="button"
        style={styles.recordingsToggle}
        onClick={async () => {
          if (recordingsOpen && activeRecording) {
            await stopRecordingPlayback({
              silent: true
            });
          }

          setRecordingsOpen((open) => !open);
        }}
      >
        Grabaciones {recordingsOpen ? '▴' : '▾'}
      </button>
      {recordingsOpen && (
        <div style={styles.recordingsContent}>
          <div style={styles.linkText}>
            Consulta los archivos almacenados en la memoria de la cámara.
          </div>
          <label style={styles.recordingsLabel} htmlFor="maccez-recordings-date">
            Fecha
          </label>
          <input
            id="maccez-recordings-date"
            type="date"
            value={recordingsDate}
            onChange={async (event) => {
              if (activeRecording) {
                await stopRecordingPlayback({
                  silent: true
                });
              }

              setRecordingsDate(event.target.value);
              setRecordingsResult(null);
              setRecordingError('');
            }}
            style={styles.cameraIdInput}
          />
          <div style={styles.cameraSelector}>
            {[0, 1, 2].map((channel) => (
              <button
                key={channel}
                type="button"
                onClick={async () => {
                  if (
                    activeRecording &&
                    (channel === 0 || activeRecording.channel !== channel)
                  ) {
                    await stopRecordingPlayback({
                      silent: true
                    });
                  }

                  setRecordingsChannel(channel);
                  setRecordingsResult(null);
                  setRecordingError('');
                }}
                style={{
                  ...styles.recordingsChannelButton,
                  ...(recordingsChannel === channel ? styles.recordingsChannelActive : {})
                }}
              >
                {channel === 0 ? 'Ambas' : channel === 1 ? 'Frontal' : 'Interior'}
              </button>
            ))}
          </div>
          <button
            type="button"
            onClick={queryRecordings}
            disabled={recordingsLoading || !recordingsDate}
            style={styles.linkButton}
          >
            {recordingsLoading ? 'Consultando cámara...' : 'Buscar grabaciones'}
          </button>
          {recordingsError && (
            <div role="alert" style={styles.recordingsError}>{recordingsError}</div>
          )}
          {recordingsResult && (
            <div style={styles.recordingsResults}>
              <strong>Archivos encontrados: {recordingsResult.items?.length ?? 0}</strong>
              {(recordingsResult.items || []).length === 0 && (
                <div style={styles.linkText}>No se encontraron grabaciones para esta fecha y canal.</div>
              )}
              {/* DIVI_EVENTS_FILTERED_V1: separa el catálogo SD de las alarmas guardadas. */}
              <div style={{display:'flex',gap:8,margin:'12px 0',flexWrap:'wrap'}}>
                <button type="button" onClick={() => setDiviEventsTab('events')}
                  style={{...styles.recordingsChannelButton,...(diviEventsTab === 'events' ? styles.recordingsChannelActive : {})}}>
                  Eventos ({recordingEventMatches.length})
                </button>
                <button type="button" onClick={() => setDiviEventsTab('clips')}
                  style={{...styles.recordingsChannelButton,...(diviEventsTab === 'clips' ? styles.recordingsChannelActive : {})}}>
                  Todas las grabaciones ({recordingItems.length})
                </button>
              </div>
              {diviEventsTab === 'events' && (
                <div style={{display:'grid',gap:10,marginBottom:14}}>
                  <div style={styles.recordingTools}>
                    <label style={styles.recordingToolLabel}>Tipo de alerta
                      <select value={diviEventKind} onChange={e => setDiviEventKind(e.target.value)} style={styles.recordingFilter}>
                        <option value="all">Todos los tipos ({recordingEventMatches.length})</option>
                        {diviEventKinds.map(kind => <option key={kind} value={kind}>{kind}</option>)}
                      </select>
                    </label>
                    <label style={styles.recordingToolLabel}>Prioridad
                      <select value={diviEventPriority} onChange={e => setDiviEventPriority(e.target.value)} style={styles.recordingFilter}>
                        <option value="all">Todas</option>
                        <option value="critical">Crítica</option>
                        <option value="warning">Advertencia</option>
                        <option value="info">Informativa</option>
                      </select>
                    </label>
                  </div>
                  <small style={styles.recordingsHint}>Las alertas son reportes realmente guardados en DIVI. El video asociado se busca por fecha, hora y canal; no es evidencia confirmada del suceso.</small>
                  {recordingEventsStatus && <small role="status" style={styles.recordingsHint}>{recordingEventsStatus}</small>}
                  {diviFilteredEvents.length === 0 && <div style={styles.linkText}>No se han recibido alarmas ADAS/DMS de la cámara Great-Will para esta fecha. No se incluyen eventos Teltonika ni se deducen alarmas examinando videos.</div>}
                  {diviFilteredEvents.map((event,i) => {
                    const related = enrichedRecordings.filter(item => item.matchedEvents.some(e => e.id === event.id));
                    return <div key={event.id || i} style={{padding:12,border:'1px solid #dbe3ee',borderRadius:10,display:'grid',gap:6}}>
                      <strong>{diviEventKindOf(event)}</strong>
                      <small>{formatRecordingEventDate(event.created_at)} · {recordingEventCategory(event)} · {String(event.event_level || 'sin nivel')} · Cámara {diviEventChannel(event) === 1 ? 'frontal' : 'interior'}</small>
                      <div style={{fontSize:12}}>{event.message || 'Sin descripción adicional'}</div>
                      <small style={styles.recordingsHint}>{related.length ? `${related.length} grabación(es) relacionadas por horario y canal` : 'Sin grabación relacionada en la consulta actual'}</small>
                      {related.length > 0 && <button type="button" disabled={recordingLoading} style={styles.linkButton}
                        onClick={() => {setDiviEventsTab('clips');setRecordingEventFilter('all');setRecordingHour('all');setRecordingSearch('');setRecordingOrder('newest');void playRecording(related[0]);}}>
                        Ver grabación relacionada ({Number(related[0].channel)===1?'frontal':'interior'})
                      </button>}
                    </div>;
                  })}
                </div>
              )}
              {diviEventsTab === 'clips' && <>
              <div style={styles.recordingTools}>
                <label style={styles.recordingToolLabel}>Buscar por hora o evento
                <input
                  aria-label="Buscar por hora"
                  placeholder="Buscar hora, ej. 14:35"
                  value={recordingSearch}
                  onChange={(event) => setRecordingSearch(event.target.value)}
                  style={styles.recordingFilter}
                /></label>
                <label style={styles.recordingToolLabel}>Horario
                <select value={recordingHour} onChange={(event) => setRecordingHour(event.target.value)}
                  aria-label="Filtrar hora" style={styles.recordingFilter}>
                  <option value="all">Todas las horas</option>
                  {Array.from({length: 24}, (_, h) => String(h).padStart(2, '0')).map(h =>
                    <option key={h} value={h}>{h}:00 – {h}:59</option>)}
                </select></label>
                <label style={styles.recordingToolLabel}>Detección IA de cámara
                <select value={recordingEventFilter} onChange={(event) => setRecordingEventFilter(event.target.value)}
                  aria-label="Filtrar tipo de evento" style={styles.recordingFilter}>
                  <option value="all">Todos los clips ({recordingItems.length})</option>
                  {recordingEventChoices.map(choice =>
                    <option key={choice.value} value={choice.value} disabled={choice.count === 0}>
                      {choice.label} ({choice.count})
                    </option>
                  )}
                </select></label>
                <label style={styles.recordingToolLabel}>Ordenar
                <select value={recordingOrder} onChange={(event) => setRecordingOrder(event.target.value)}
                  aria-label="Orden de grabaciones" style={styles.recordingFilter}>
                  <option value="newest">Más recientes</option>
                  <option value="oldest">Más antiguas</option>
                </select></label>
              </div>
              <div style={styles.recordingsHint}>
                {recordingEventMatches.length} eventos registrados para esta consulta; {enrichedRecordings.filter(item => item.eventTags.length > 0).length} clips con coincidencia por horario.
                La coincidencia no significa que el evento haya iniciado la grabación.
                {recordingEventsStatus && <strong> {recordingEventsStatus}</strong>}
              </div>
              {recordingEventChoices.every(choice => !choice.count || choice.value === 'none') && (
                <div style={styles.recordingsHint} role="status">
                  No hay alarmas ADAS/DMS de Great-Will vinculadas a estos clips. Las grabaciones siguen disponibles sin etiquetas de IA inventadas.
                </div>
              )}
              {recordingAllEvents.length > 0 && (
                <details style={styles.recordingGroup}>
                  <summary style={styles.recordingGroupTitle}>
                    Detecciones IA de cámara ese día ({recordingEventMatches.length}) · ver aparte
                  </summary>
                  <div style={styles.recordingsHint}>
                    Estos eventos no necesariamente tienen un clip en la tarjeta SD. Se muestran como referencia independiente.
                  </div>
                  {recordingAllEvents.map((event, i) => (
                    <div key={event.id || i} style={{padding:'8px 10px',borderBottom:'1px solid #e2e8f0',fontSize:12}}>
                      <strong>{formatRecordingEventDate(event.created_at)} · {event.title || event.event_type || 'Evento'}</strong>
                      <div>{event.message || ''}</div>
                      <button type="button" style={{...styles.recordingPlayButton,marginTop:6}}
                        onClick={() => {
                          setRecordingEventFilter('all');
                          setRecordingHour('all');
                          setRecordingSearch(String(event.title || event.event_type || ''));
                        }}>
                        Filtrar clips relacionados con este evento
                      </button>
                    </div>
                  ))}
                  {recordingEventMatches.length > recordingAllEvents.length &&
                    <div style={styles.recordingsHint}>Mostrando los primeros {recordingAllEvents.length} eventos.</div>}
                </details>
              )}
              <div style={styles.recordingSummary}>
                {visibleRecordings.length} de {recordingItems.length} clips · {recordingsChannel === 0 ? 'Ambas' : recordingsChannel === 1 ? 'Frontal' : 'Interior'}
              </div>
              {visibleRecordings.length === 0 && recordingItems.length > 0 && (
                <div style={styles.linkText}>No hay clips que coincidan con estos filtros.</div>
              )}
              {Object.entries(recordingGroups).map(([hour, items]) => (
                <details key={hour} open={visibleRecordings.length <= 18} style={styles.recordingGroup}>
                  <summary style={styles.recordingGroupTitle}>{hour} · {items.length} clips</summary>
                  {items.map((item, index) => {
                    const isActive = activeRecording?.start === item.start &&
                      activeRecording?.end === item.end && Number(activeRecording?.channel) === Number(item.channel);
                    return (
                      <button type="button" key={`${item.start}-${item.end}-${index}`}
                        disabled={recordingLoading}
                        onClick={() => playRecording(item)}
                        style={{...styles.recordingCompactRow,
                          ...(isActive ? styles.recordingItemActive : {})}}>
                        <span style={styles.recordingCompactIcon}>▶</span>
                        <span style={styles.recordingCompactDetails}>
                          <strong>{recordingTime(item.start)} – {recordingTime(item.end)} {recordingsChannel === 0 ? `· ${Number(item.channel) === 1 ? 'Frontal' : 'Interior'}` : ''}</strong>
                          <small>{recordingDuration(item.start, item.end)} · {typeof item.bytes === 'number'
                            ? `${(item.bytes / (1024 * 1024)).toFixed(1)} MB` : 'Tamaño desconocido'}</small>
                          <small style={styles.recordingEventTag}>
                            {item.eventTags.length ? `Coincide: ${item.matchedEvents.map(e => e.title || recordingEventCategory(e)).slice(0,2).join(' · ')}${item.matchedEvents.length > 2 ? ` +${item.matchedEvents.length-2}` : ''}` : 'Sin evento asociado por horario'}
                          </small>
                        </span>
                        <span style={styles.recordingCompactAction}>{isActive ? (recordingLoading ? 'Cargando…' : 'En curso') : 'Ver ›'}</span>
                      </button>
                    );
                  })}
                </details>
              ))}
              </>}
              {activeRecording && (
                <div style={{...styles.recordingPlayerCard, ...(recordingExpanded ? styles.recordingPlayerExpanded : {})}}>
                  <div style={styles.recordingPlayerHeader}>
                    <div>
                      <strong>
                        {activeRecording.channel === 1
                          ? 'Grabación frontal'
                          : 'Grabación interior'}
                      </strong>

                      <div style={styles.recordingsHint}>
                        {recordingTime(activeRecording.start)}
                        {' → '}
                        {recordingTime(activeRecording.end)}
                        {' · '}
                        {recordingDuration(
                          activeRecording.start,
                          activeRecording.end
                        )}
                      </div>
                    </div>

                    <div style={{display: 'flex', gap: 6}}>
                      <button type="button" onClick={() => setRecordingExpanded(x => !x)}
                        style={styles.recordingStopButton}>{recordingExpanded ? 'Reducir' : 'Expandir'}</button>
                      <button type="button" onClick={() => { setRecordingExpanded(false); stopRecordingPlayback(); }}
                        style={styles.recordingStopButton}>Cerrar</button>
                    </div>
                  </div>

                  <div style={styles.recordingVideoStage}>
                    <video
                      ref={recordingVideoRef}
                      controls
                      playsInline
                      onLoadedData={(e) => { e.currentTarget.playbackRate = recordingSpeed; updateRecordingSeekBounds(e.currentTarget); }}
                      onTimeUpdate={(e) => {
                        setRecordingNow(e.currentTarget.currentTime || 0);
                        updateRecordingSeekBounds(e.currentTarget);
                      }}
                      onProgress={(e) => updateRecordingSeekBounds(e.currentTarget)}
                      onLoadedMetadata={(e) => updateRecordingSeekBounds(e.currentTarget)}
                      onDurationChange={(e) => {
                        setRecordingLength(Number.isFinite(e.currentTarget.duration) ? e.currentTarget.duration : 0);
                        updateRecordingSeekBounds(e.currentTarget);
                      }}
                      style={styles.video}
                    />

                    {recordingLoading && (
                      <div
                        style={styles.videoLoadingOverlay}
                        role="status"
                      >
                        <div
                          style={styles.videoLoadingSpinner}
                        />
                        <strong
                          style={styles.videoLoadingTitle}
                        >
                          Preparando grabación
                        </strong>
                        <span
                          style={styles.videoLoadingText}
                        >
                          Leyendo video desde la memoria de la cámara…
                        </span>
                      </div>
                    )}
                  </div>

                  <div style={{display:'grid',gap:6,paddingTop:10}}>
                    <button type="button" onClick={downloadRecording}
                      disabled={!recordingGeneration || recordingDownloadBusy || recordingLoading}
                      style={styles.linkButton}>
                      {recordingDownloadBusy ? 'Preparando descarga…' : 'Descargar videoclip MP4'}
                    </button>
                    <small style={styles.recordingsHint}>Descarga únicamente los segundos recibidos por DIVI, no garantiza la duración completa anunciada en la SD. Espera a que termine la transmisión.</small>
                    {recordingDownloadMessage && <small role="status" style={styles.recordingsHint}>{recordingDownloadMessage}</small>}
                  </div>
                  <div style={styles.recordingTransport}>
                    <button type="button" onClick={() => skipRecording(-10)} disabled={!recordingPlaying}>−10 s</button>
                    <button type="button" disabled={!recordingPlaying}
                      onClick={() => { const v = recordingVideoRef.current; if (v) v.paused ? v.play().catch(()=>{}) : v.pause(); }}>Play / Pausa</button>
                    <button type="button" onClick={() => skipRecording(10)} disabled={!recordingPlaying}>+10 s</button>
                  </div>
                  <div style={{display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', margin: '8px 0'}}>
                    <label htmlFor="divi-recording-speed" style={{fontSize: 13, fontWeight: 600}}>Velocidad del video</label>
                    <select id="divi-recording-speed" value={recordingSpeed}
                      onChange={(event) => {
                        const speed = Number(event.target.value);
                        setRecordingSpeed(speed);
                        if (recordingVideoRef.current) recordingVideoRef.current.playbackRate = speed;
                      }}
                      style={{padding: '6px 10px', borderRadius: 8, border: '1px solid #cbd5e1'}}>
                      <option value={0.25}>0,25× (timelapse más lento)</option>
                      <option value={0.5}>0,5×</option>
                      <option value={1}>1× (normal)</option>
                      <option value={2}>2×</option>
                    </select>
                  </div>
                  <div style={{fontSize: 12, opacity: 0.8, marginBottom: 8}}>
                    El intervalo de la lista indica el horario del archivo. El tiempo navegable depende del video recibido de la SD.
                    En ACC OFF, una grabación timelapse puede avanzar horas en pocos segundos; reducir la velocidad no recupera fotogramas omitidos por la cámara.
                  </div>
                  <div style={styles.recordingTimeline}>
                    <span>{formatRecordingClock(recordingNow)}</span>
                    <input type="range"
                      min={recordingSeekBounds?.start ?? 0}
                      max={recordingSeekBounds?.end ?? 1}
                      step="0.1"
                      value={recordingSeekBounds ? Math.min(recordingSeekBounds.end, Math.max(recordingSeekBounds.start, recordingNow)) : 0}
                      onChange={(event) => seekRecording(Number(event.target.value))}
                      disabled={!recordingSeekBounds}
                      aria-label="Posición navegable de reproducción" />
                    <span>{recordingSeekBounds ? formatRecordingClock(recordingSeekBounds.end) : '--:--'}</span>
                  </div>
                  <div style={styles.recordingsHint}>
                    La barra muestra únicamente el tramo disponible para adelantar o regresar.
                    Mientras la cámara envía el video, ese tramo puede crecer y la barra puede estar temporalmente deshabilitada.
                    El horario del catálogo no garantiza que todo el archivo haya llegado.
                    Las grabaciones de estacionamiento en timelapse avanzan más rápido por diseño de la cámara.
                    El servidor no conserva permanentemente estos videos.
                  </div>
                  {recordingPlaying && (
                    <div style={styles.recordingStatus}>
                      ● Reproduciendo desde la memoria de la cámara
                    </div>
                  )}

                  {recordingError && (
                    <div
                      role="alert"
                      style={styles.recordingsError}
                    >
                      {recordingError}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  )}

  {vehicleId &&
    cameraState?.camera &&
    cameraCapabilities.faceRecognition && (
      <div style={styles.driverCard}>
        <button
          type="button"
          style={styles.recordingsToggle}
          onClick={async () => {
            const nextOpen = !driverOpen;
            setDriverOpen(nextOpen);

            if (nextOpen) {
              await Promise.all([queryRegisteredDrivers(), queryDriverEvents()]);
            }
          }}
        >
          Conductor {driverOpen ? '▴' : '▾'}
        </button>

        {driverOpen && (
          <div style={styles.driverContent}>
            <div style={styles.driverSectionTitle}>Conductores autorizados</div>
            <div style={styles.linkText}>Registra la persona y su fotografía. DIVI la sincroniza directamente con la base facial de esta GD14.</div>

            <button type="button" style={styles.driverAddButton} onClick={() => { setDriverFormOpen(!driverFormOpen); setDriverRegistryError(''); setDriverRegistryMessage(''); }}>
              {driverFormOpen ? 'Cancelar' : '+ Agregar conductor'}
            </button>

            {driverFormOpen && (
              <form onSubmit={registerFaceDriver} style={styles.driverForm}>
                <label style={styles.driverFieldLabel}>Nombre del conductor</label>
                <input value={driverName} onChange={(e) => setDriverName(e.target.value)} maxLength={120} required placeholder="Ej. Carlos Ramírez" style={styles.driverInput} />
                <label style={styles.driverFieldLabel}>Documento o identificación <span style={styles.driverOptional}>(opcional)</span></label>
                <input value={driverCertificate} onChange={(e) => setDriverCertificate(e.target.value)} maxLength={32} placeholder="Máximo 32 caracteres" style={styles.driverInput} />
                <label style={styles.driverFieldLabel}>Fotografía del rostro</label>
                <input type="file" accept="image/jpeg,.jpg,.jpeg" capture="user" required={!driverPhoto} style={styles.driverFileInput} onChange={(e) => {
                  const file = e.target.files?.[0] || null;
                  if (driverPhotoPreview?.startsWith('blob:')) URL.revokeObjectURL(driverPhotoPreview);
                  setDriverPhoto(file);
                  setDriverPhotoPreview(file ? URL.createObjectURL(file) : '');
                }} />
                {driverPhotoPreview && <img src={driverPhotoPreview} alt="Vista previa del conductor" style={styles.driverPreview} />}
                <button type="submit" disabled={driverRegistryLoading || !driverName.trim() || !driverPhoto} style={styles.driverSaveButton}>
                  {driverRegistryLoading ? 'Sincronizando con la cámara…' : 'Guardar y sincronizar'}
                </button>
              </form>
            )}

            {driverRegistryMessage && <div style={styles.driverSuccess}>{driverRegistryMessage}</div>}
            {driverRegistryError && <div role="alert" style={styles.recordingsError}>{driverRegistryError}</div>}

            {registeredDrivers.length > 0 && (
              <div style={styles.driverRegistryList}>
                {registeredDrivers.map((driver) => (
                  <div key={driver.id} style={styles.driverRegistryItem}>
                    <div><strong>{driver.name}</strong><div style={styles.driverRegistryId}>{driver.certificate || driver.faceId}</div></div>
                    <div style={styles.driverRegistryRight}>
                      <span style={{...styles.driverSyncBadge, ...(driver.syncStatus === 'SYNCED' ? styles.driverSyncOk : driver.syncStatus === 'FAILED' ? styles.driverSyncFailed : styles.driverSyncPending)}}>
                        {driver.syncStatus === 'SYNCED' ? 'Sincronizado' : driver.syncStatus === 'FAILED' ? 'Falló' : 'Pendiente'}
                      </span>
                      {driver.syncStatus === 'FAILED' && <button type="button" disabled={driverRegistryLoading} onClick={() => retryFaceDriverSync(driver.id)} style={styles.driverRetryButton}>Reintentar</button>}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {!driverRegistryLoading && registeredDrivers.length === 0 && !driverRegistryError && <div style={styles.driverEmpty}>Aún no hay conductores autorizados.</div>}

            <div style={styles.driverDivider} />
            <div style={styles.driverSectionTitle}>Identificaciones recientes</div>
            <div style={styles.linkText}>
              Identificaciones reportadas por la cámara de este vehículo.
            </div>

            <button
              type="button"
              onClick={queryDriverEvents}
              disabled={driverLoading}
              style={styles.driverRefreshButton}
            >
              {driverLoading
                ? 'Actualizando…'
                : 'Actualizar identificaciones'}
            </button>

            {driverError && (
              <div
                role="alert"
                style={styles.recordingsError}
              >
                {driverError}
              </div>
            )}

            {!driverLoading &&
              !driverError &&
              driverEvents.length === 0 && (
                <div style={styles.driverEmpty}>
                  Aún no hay identificaciones registradas.
                </div>
              )}

            {driverEvents.length > 0 && (
              <div style={styles.driverList}>
                {driverEvents.map((event, index) => {
                  const recognized =
                    Number(event.recognitionResult) === 0;

                  return (
                    <div
                      key={event.id}
                      style={{
                        ...styles.driverEvent,
                        ...(index === 0
                          ? styles.driverEventLatest
                          : {})
                      }}
                    >
                      <div style={styles.driverEventTop}>
                        <div>
                          <div
                            style={{
                              ...styles.driverResult,
                              ...(recognized
                                ? styles.driverRecognized
                                : styles.driverNotRecognized)
                            }}
                          >
                            {recognized
                              ? '✓ Conductor reconocido'
                              : event.resultLabel ||
                                'Conductor no reconocido'}
                          </div>

                          <div style={styles.driverDate}>
                            {formatCameraEventDate(
                              event.receivedAt
                            )}
                          </div>
                        </div>

                        {index === 0 && (
                          <span style={styles.driverLatest}>
                            Último
                          </span>
                        )}
                      </div>

                      {driverPhotos[event.id] && (
                        <img
                          src={driverPhotos[event.id]}
                          alt="Captura del conductor"
                          style={styles.driverPhoto}
                        />
                      )}

                      <div style={styles.driverMeta}>
                        {event.faceId && (
                          <div>
                            <span>Identificador</span>
                            <strong>{event.faceId}</strong>
                          </div>
                        )}

                        {event.similarityPercent != null && (
                          <div>
                            <span>Similitud</span>
                            <strong>
                              {Number(
                                event.similarityPercent
                              ).toFixed(2)}%
                            </strong>
                          </div>
                        )}

                        {event.threshold != null && (
                          <div>
                            <span>Umbral</span>
                            <strong>
                              {event.threshold}%
                            </strong>
                          </div>
                        )}

                        {event.comparisonLabel && (
                          <div>
                            <span>Origen</span>
                            <strong>
                              {String(
                                event.comparisonLabel
                              ).replaceAll('_', ' ')}
                            </strong>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>
    )}
  </>
)}
      {module !== 'camaras' && (
      <div style={styles.grid}>
        {current.items.map(
          (item, index) => (
            <div
              key={`${module}-${index}`}
              style={styles.card}
            >
              <span style={styles.cardNumber}>
                {String(index + 1).padStart(
                  2,
                  '0'
                )}
              </span>

              <strong style={styles.cardText}>
                {item}
              </strong>

              {module !== 'cuenta' && (
                <span style={styles.status}>
                  En preparación
                </span>
              )}
            </div>
          )
        )}
      </div>
      )}
    </section>
  );
}



function formatCameraEventDate(value) {
  if (!value) return 'Fecha no disponible';

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleString('es-CO', {
    dateStyle: 'medium',
    timeStyle: 'short'
  });
}

function parseRecordingTimestamp(value) {
  if (!value) return NaN;
  // Fechas SD sin zona horaria: se interpretan como hora local de la interfaz.
  const raw = String(value).replace(' ', 'T');
  const ms = Date.parse(raw);
  return Number.isFinite(ms) ? ms : NaN;
}
function formatRecordingEventDate(value) {
  if (!value) return '--:--';
  const date = new Date(value);
  return Number.isFinite(date.getTime())
    ? date.toLocaleTimeString('es-CO', {hour: '2-digit', minute: '2-digit', hour12: false})
    : String(value);
}
// DIVI_GREATWILL_ONLY_V2: el origen se valida con event_type del receptor,
// nunca con palabras en el título ni con registros generales del GPS.
function isGreatWillCameraAIEvent(event) {
  return /^(ADAS|DMS)_/.test(String(event?.event_type || '').toUpperCase());
}
function recordingEventCategory(event) {
  const type = String(event?.event_type || '').toUpperCase();
  if (type.startsWith('ADAS_')) return 'ADAS';
  if (type.startsWith('DMS_')) return 'DMS';
  return 'NONE';
}
function diviEventChannel(event) {
  const category = recordingEventCategory(event);
  return category === 'ADAS' ? 1 : category === 'DMS' ? 2 : null;
}
function diviEventKindOf(event) {
  const type = String(event?.event_type || '').toUpperCase();
  // Estos nombres corresponden al decodificador real instalado para Great-Will;
  // no se confunden con códigos EVENTSET (comandos de configuración).
  const names = {
    ADAS_COLISION_FRONTAL: 'ADAS · Riesgo de colisión frontal',
    ADAS_SALIDA_CARRIL: 'ADAS · Salida de carril',
    ADAS_DISTANCIA_VEHICULO: 'ADAS · Distancia peligrosa',
    ADAS_RIESGO_PEATON: 'ADAS · Riesgo para peatón',
    ADAS_COLISION_PEATON: 'ADAS · Riesgo para peatón',
    ADAS_CAMBIO_CARRIL_FRECUENTE: 'ADAS · Cambio frecuente de carril',
    ADAS_SENAL_TRANSITO: 'ADAS · Señales de tránsito',
    ADAS_CAPTURA_ACTIVA: 'ADAS · Captura automática',
    DMS_FATIGA: 'DMS · Fatiga del conductor',
    DMS_USO_TELEFONO: 'DMS · Uso del celular / teléfono',
    DMS_FUMAR: 'DMS · Conductor fumando',
    DMS_DISTRACCION: 'DMS · Distracción del conductor',
    DMS_CONDUCTOR_ANORMAL: 'DMS · Conductor no detectado o anormal',
    DMS_CAPTURA_AUTOMATICA: 'DMS · Captura automática',
    DMS_CAMBIO_CONDUCTOR: 'DMS · Cambio de conductor',
    DMS_OJOS_CERRADOS: 'DMS · Ojos cerrados continuamente',
    DMS_MANOS_VOLANTE: 'DMS · Manos fuera del volante',
  };
  return names[type] || `${recordingEventCategory(event)} · ${type.replace(/^(ADAS|DMS)_/, '').replaceAll('_',' ').toLowerCase()}`;
}

function formatRecordingClock(seconds) {
  if (!Number.isFinite(seconds) || seconds < 0) return '00:00';
  const n = Math.floor(seconds);
  return `${String(Math.floor(n / 60)).padStart(2, '0')}:${String(n % 60).padStart(2, '0')}`;
}

function recordingTime(value) {
  if (typeof value !== 'string') return '--:--';

  const match = value.match(
    /(?:\d{4}-\d{2}-\d{2}\s+)?(\d{2}):(\d{2}):(\d{2})/
  );

  return match
    ? `${match[1]}:${match[2]}`
    : '--:--';
}

function recordingDuration(start, end) {
  if (
    typeof start !== 'string' ||
    typeof end !== 'string'
  ) {
    return 'Duración no disponible';
  }

  const startMs = Date.parse(
    start.replace(' ', 'T')
  );

  const endMs = Date.parse(
    end.replace(' ', 'T')
  );

  if (
    !Number.isFinite(startMs) ||
    !Number.isFinite(endMs) ||
    endMs < startMs
  ) {
    return 'Duración no disponible';
  }

  const seconds = Math.max(
    0,
    Math.round((endMs - startMs) / 1000)
  );

  if (seconds < 60) {
    return `${seconds} s`;
  }

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  if (!remainingSeconds) {
    return `${minutes} min`;
  }

  return `${minutes} min ${remainingSeconds} s`;
}

const styles = {
  // MACCEZ_GD14_DRIVER_UI_V1
  driverCard: {
    marginBottom: '16px',
    padding: '14px',
    borderRadius: '16px',
    background: 'rgba(255,255,255,0.9)',
    border: '1px solid rgba(15,23,42,0.08)'
  },
  driverContent: {
    paddingTop: '12px'
  },
  driverSectionTitle: { marginTop: '4px', color: '#063b78', fontSize: '13px', fontWeight: 950 },
  driverAddButton: { width: '100%', marginTop: '12px', padding: '11px 12px', borderRadius: '11px', border: '1px solid #bfdbfe', background: '#eff6ff', color: '#063b78', fontSize: '12px', fontWeight: 900, cursor: 'pointer' },
  driverForm: { display: 'grid', gap: '8px', marginTop: '12px', padding: '12px', borderRadius: '13px', background: '#f8fafc', border: '1px solid #e2e8f0' },
  driverFieldLabel: { marginTop: '3px', color: '#334155', fontSize: '11px', fontWeight: 850 },
  driverOptional: { color: '#94a3b8', fontWeight: 700 },
  driverInput: { width: '100%', boxSizing: 'border-box', padding: '11px 12px', borderRadius: '10px', border: '1px solid #cbd5e1', background: '#fff', color: '#0f172a', fontSize: '13px', outline: 'none' },
  driverFileInput: { width: '100%', boxSizing: 'border-box', padding: '9px', borderRadius: '10px', border: '1px dashed #94a3b8', background: '#fff', fontSize: '12px' },
  driverPreview: { display: 'block', width: '100%', maxHeight: '260px', objectFit: 'cover', borderRadius: '12px', background: '#0f172a' },
  driverSaveButton: { width: '100%', padding: '11px 12px', border: 0, borderRadius: '11px', background: '#2563eb', color: '#fff', fontSize: '12px', fontWeight: 900, cursor: 'pointer' },
  driverSuccess: { marginTop: '10px', padding: '10px 12px', borderRadius: '11px', background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', fontSize: '12px', fontWeight: 850 },
  driverRegistryList: { display: 'grid', gap: '8px', marginTop: '12px' },
  driverRegistryItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', padding: '11px 12px', borderRadius: '12px', border: '1px solid #e2e8f0', background: '#fff', color: '#0f172a', fontSize: '12px' },
  driverRegistryId: { marginTop: '3px', color: '#64748b', fontSize: '10px' },
  driverRegistryRight: { display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap', justifyContent: 'flex-end' },
  driverSyncBadge: { padding: '4px 7px', borderRadius: '999px', fontSize: '9px', fontWeight: 900 },
  driverSyncOk: { background: '#dcfce7', color: '#166534' },
  driverSyncFailed: { background: '#fee2e2', color: '#b91c1c' },
  driverSyncPending: { background: '#fef3c7', color: '#92400e' },
  driverRetryButton: { padding: '5px 8px', borderRadius: '8px', border: '1px solid #bfdbfe', background: '#eff6ff', color: '#1d4ed8', fontSize: '9px', fontWeight: 900, cursor: 'pointer' },
  driverDivider: { height: '1px', margin: '18px 0 14px', background: '#e2e8f0' },
  driverRefreshButton: {
    width: '100%',
    marginTop: '12px',
    border: '1px solid #bfdbfe',
    borderRadius: '11px',
    padding: '10px 12px',
    background: '#eff6ff',
    color: '#063b78',
    fontSize: '12px',
    fontWeight: 900,
    cursor: 'pointer'
  },
  driverEmpty: {
    marginTop: '14px',
    padding: '16px',
    borderRadius: '13px',
    background: '#f8fafc',
    color: '#64748b',
    fontSize: '12px',
    textAlign: 'center'
  },
  driverList: {
    display: 'grid',
    gap: '10px',
    marginTop: '14px'
  },
  driverEvent: {
    padding: '13px',
    borderRadius: '14px',
    border: '1px solid #e2e8f0',
    background: '#f8fafc'
  },
  driverEventLatest: {
    border: '1px solid #bfdbfe',
    background: '#f8fbff'
  },
  driverEventTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '12px'
  },
  driverResult: {
    fontSize: '13px',
    fontWeight: 900
  },
  driverRecognized: {
    color: '#15803d'
  },
  driverNotRecognized: {
    color: '#b91c1c'
  },
  driverDate: {
    marginTop: '3px',
    color: '#64748b',
    fontSize: '11px'
  },
  driverLatest: {
    padding: '4px 8px',
    borderRadius: '999px',
    background: '#dbeafe',
    color: '#1d4ed8',
    fontSize: '10px',
    fontWeight: 900
  },
  driverPhoto: {
    display: 'block',
    width: '100%',
    maxHeight: '280px',
    objectFit: 'cover',
    marginTop: '12px',
    borderRadius: '12px',
    background: '#0f172a'
  },
  driverMeta: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '8px',
    marginTop: '12px'
  },
  recordingsCard: {
    marginBottom: '16px', padding: '14px', borderRadius: '16px',
    background: 'rgba(255,255,255,0.9)', border: '1px solid rgba(15,23,42,0.08)'
  },
  recordingsToggle: {
    width: '100%', textAlign: 'left', padding: '12px', cursor: 'pointer',
    border: 0, borderRadius: '12px', background: '#eaf3fb',
    color: '#063b78', fontWeight: 900, fontSize: '14px'
  },
  recordingsContent: { paddingTop: '12px' },
  recordingsLabel: { display: 'block', marginTop: '12px', fontSize: '12px', fontWeight: 850 },
  recordingsChannelButton: {
    marginTop: '12px', padding: '10px', borderRadius: '12px',
    background: '#eff6ff', color: '#063b78', border: '1px solid #bfdbfe',
    cursor: 'pointer', fontWeight: 850
  },
  recordingsChannelActive: { background: '#2563eb', color: '#fff' },
  recordingPlayButton: {
    width: '100%',
    marginTop: '10px',
    border: '1px solid #bfdbfe',
    borderRadius: '11px',
    padding: '10px 12px',
    background: '#eff6ff',
    color: '#063b78',
    fontSize: '12px',
    fontWeight: 900,
    cursor: 'pointer',
    WebkitAppearance: 'none',
    appearance: 'none',
    outline: 'none',
    boxShadow: 'none'
  },
  recordingPlayButtonActive: {
    background: '#2563eb',
    border: '1px solid #2563eb',
    color: '#fff',
    boxShadow: '0 5px 14px rgba(37,99,235,0.18)'
  },
  recordingPlayerCard: {
    marginTop: '14px',
    display: 'grid',
    gap: '10px'
  },
  recordingPlayerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px'
  },
  recordingStopButton: {
    border: 0,
    borderRadius: '10px',
    padding: '9px 12px',
    fontWeight: 850,
    cursor: 'pointer'
  },
  recordingVideoStage: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '14px',
    background: '#000',
    minHeight: '180px'
  },
  recordingStatus: {
    fontSize: '12px',
    fontWeight: 800
  },
  recordingsError: { marginTop: '12px', color: '#b91c1c', fontSize: '12px', overflowWrap: 'anywhere' },
  recordingTools: {display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gap: '7px'},
  recordingFilter: {width: '100%', minWidth: 0, minHeight: '42px', boxSizing: 'border-box', padding: '10px 8px', borderRadius: '10px', border: '1px solid #cbd5e1', fontSize: '14px', color: '#0f172a', WebkitTextFillColor: '#0f172a', background: '#fff'},
  recordingSummary: {color: '#475569', fontSize: '12px', fontWeight: 750},
  recordingEventTag: {color: '#1d4ed8', overflowWrap: 'anywhere', lineHeight: 1.3},
  recordingToolLabel: {display: 'grid', gap: '5px', color: '#334155', fontSize: '12px', fontWeight: 750},
  recordingGroup: {border: '1px solid #dbe5f0', borderRadius: '12px', overflow: 'hidden', background: '#fff'},
  recordingGroupTitle: {padding: '12px', background: '#eff6ff', fontWeight: 850, cursor: 'pointer', fontSize: '13px'},
  recordingCompactRow: {width: '100%', display: 'flex', alignItems: 'center', textAlign: 'left', gap: '10px', background: '#fff', padding: '9px 12px', border: 0, borderTop: '1px solid #edf2f7', color: '#0f172a', cursor: 'pointer'},
  recordingCompactIcon: {width: '32px', height: '32px', borderRadius: '9px', flexShrink: 0, background: '#eff6ff', color: '#2563eb', display: 'grid', placeItems: 'center'},
  recordingCompactDetails: {display: 'grid', flex: 1, minWidth: 0, gap: '2px', fontSize: '13px'},
  recordingCompactAction: {color: '#2563eb', fontSize: '11px', fontWeight: 800},
  recordingTransport: {display: 'flex', gap: '6px', justifyContent: 'center', paddingTop: '9px'},
  recordingTimeline: {display: 'flex', alignItems: 'center', gap: '8px', fontSize: '11px'},
  recordingPlayerExpanded: {position: 'fixed', inset: 'env(safe-area-inset-top, 0px) 0 env(safe-area-inset-bottom, 0px) 0', zIndex: 99999, overflowY: 'auto', borderRadius: 0, margin: 0, background: '#fff', padding: '16px'},
  recordingsResults: {
    marginTop: '14px',
    display: 'grid',
    gap: '10px',
    fontSize: '12px'
  },
  recordingsItem: {
    display: 'flex',
    flexDirection: 'column',
    padding: '13px',
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: '14px',
    outline: 'none',
    boxShadow: 'none',
    transition: 'border-color 160ms ease, box-shadow 160ms ease, background 160ms ease'
  },
  recordingsItemActive: {
    background: '#eff6ff',
    border: '2px solid #2563eb',
    boxShadow: '0 6px 18px rgba(37,99,235,0.12)'
  },
  recordingItemTop: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '12px'
  },
  recordingChannelName: {
    color: '#64748b',
    fontSize: '10px',
    lineHeight: '13px',
    fontWeight: 900,
    letterSpacing: '0.5px',
    textTransform: 'uppercase'
  },
  recordingTimeRange: {
    marginTop: '3px',
    color: '#0f172a',
    fontSize: '19px',
    lineHeight: '24px',
    fontWeight: 950,
    letterSpacing: '-0.4px'
  },
  recordingTimeArrow: {
    display: 'inline-block',
    margin: '0 7px',
    color: '#60a5fa',
    fontWeight: 700
  },
  recordingIndex: {
    minWidth: '27px',
    height: '27px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '9px',
    background: '#eaf3fb',
    color: '#2563eb',
    fontSize: '10px',
    fontWeight: 950
  },
  recordingMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    marginTop: '9px'
  },
  recordingMetaChip: {
    padding: '4px 7px',
    borderRadius: '7px',
    background: '#fff',
    border: '1px solid #e2e8f0',
    color: '#64748b',
    fontSize: '10px',
    lineHeight: '12px',
    fontWeight: 800
  },
  recordingsHint: {
    color: '#64748b',
    fontSize: '11px',
    lineHeight: '16px'
  },
  wrapper: {
    position: 'absolute',
    inset: 0,
    zIndex: 7000,

    padding:
      'calc(env(safe-area-inset-top, 0px) + 76px) 18px calc(env(safe-area-inset-bottom, 0px) + 92px)',

    boxSizing: 'border-box',
    overflowY: 'auto',

    background:
      'linear-gradient(160deg, #f8fafc 0%, #eaf3fb 58%, #dbeafe 100%)',

    color: '#0f172a'
  },

  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '16px'
  },

  eyebrow: {
    color: '#2563eb',
    fontSize: '10px',
    lineHeight: '12px',
    fontWeight: 900,
    letterSpacing: '1px',
    textTransform: 'uppercase'
  },

  title: {
    margin: '4px 0 0',

    color: '#063b78',

    fontSize: '30px',
    lineHeight: '34px',
    fontWeight: 950,
    letterSpacing: '-1px'
  },

  closeButton: {
    width: '38px',
    height: '38px',
    padding: 0,

    borderRadius: '50%',

    border:
      '1px solid rgba(15,23,42,0.10)',

    background:
      'rgba(255,255,255,0.78)',

    color: '#0f172a',

    fontSize: '23px',
    lineHeight: 1,

    cursor: 'pointer'
  },

  description: {
    maxWidth: '520px',

    margin: '14px 0 20px',

    color: '#475569',

    fontSize: '13px',
    lineHeight: '19px',
    fontWeight: 650
  },

  grid: {
    display: 'grid',
    gridTemplateColumns:
      'repeat(2, minmax(0, 1fr))',
    gap: '10px'
  },

  card: {
    minHeight: '112px',

    padding: '14px',

    boxSizing: 'border-box',
    borderRadius: '18px',

    background:
      'rgba(255,255,255,0.78)',

    border:
      '1px solid rgba(255,255,255,0.92)',

    boxShadow:
      '0 10px 25px rgba(15,23,42,0.08)',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },

  cardNumber: {
    color: '#3b82f6',

    fontSize: '9px',
    fontWeight: 900
  },

  cardText: {
    marginTop: '9px',

    color: '#0f172a',

    fontSize: '12px',
    lineHeight: '15px',
    fontWeight: 850
  },

  status: {
    marginTop: 'auto',
    paddingTop: '10px',

    color: '#64748b',

    fontSize: '8px',
    fontWeight: 800,
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },

  linkCard: {
    marginBottom: '14px',
    padding: '14px',
    borderRadius: '16px',
    background: 'rgba(255,255,255,0.86)',
    border: '1px solid rgba(15,23,42,0.08)',
    boxShadow: '0 8px 20px rgba(15,23,42,0.07)'
  },

  linkTitle: {
    color: '#063b78',
    fontSize: '14px',
    fontWeight: 900,
    marginBottom: '6px'
  },

  linkSubtitle: {
    color: '#7dd3fc',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 900,
    marginBottom: '8px'
  },

  cameraIdInput: {
    width: '100%',
    boxSizing: 'border-box',
    marginTop: '12px',
    padding: '12px 13px',
    borderRadius: '12px',
    border: '1px solid rgba(15,23,42,0.14)',
    outline: 'none',
    background: '#fff',
    color: '#0f172a',
    fontSize: '14px',
    fontWeight: 750
  },

  verifiedCamera: {
    marginTop: '12px',
    padding: '12px',
    borderRadius: '14px',
    background: '#f0fdf4',
    border: '1px solid #bbf7d0'
  },

  verifiedCameraTitle: {
    color: '#166534',
    fontSize: '13px',
    fontWeight: 900
  },

  cameraOnline: {
    marginTop: '4px',
    color: '#16a34a',
    fontSize: '11px',
    fontWeight: 900
  },

  verifiedCameraId: {
    marginTop: '5px',
    color: '#475569',
    fontSize: '11px',
    fontWeight: 700
  },

  cameraLinkMessage: {
    marginTop: '10px',
    color: '#475569',
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: 750
  },

  cancelLinkButton: {
    marginTop: '8px',
    width: '100%',
    padding: '9px 12px',
    borderRadius: '12px',
    border: '1px solid rgba(15,23,42,0.10)',
    background: 'transparent',
    color: '#64748b',
    fontSize: '11px',
    fontWeight: 850,
    cursor: 'pointer'
  },

  linkText: {
    color: '#475569',
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 650
  },

  linkSuccess: {
    color: '#15803d',
    fontSize: '13px',
    fontWeight: 900,
    marginBottom: '4px'
  },

  linkWaiting: {
    color: '#2563eb',
    fontSize: '13px',
    fontWeight: 900,
    marginBottom: '4px'
  },

  linkButton: {
    marginTop: '10px',
    width: '100%',
    padding: '11px 14px',
    borderRadius: '12px',
    border: 'none',
    background: '#2563eb',
    color: '#fff',
    fontSize: '12px',
    fontWeight: 900,
    cursor: 'pointer'
  },

  videoCard: {
  marginBottom: '18px',
  padding: '10px',
  borderRadius: '18px',
  background: '#000',
  boxShadow:
    '0 8px 24px rgba(15,23,42,0.16)'
},

videoStage: {
  position: 'relative',
  width: '100%',
  aspectRatio: '16 / 9',
  borderRadius: '12px',
  overflow: 'hidden',
  background: '#090e18'
},
videoLoadingOverlay: {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  padding: '18px',
  textAlign: 'center',
  background: 'linear-gradient(145deg, #0c182a, #060a11)',
  color: '#fff',
  pointerEvents: 'none'
},
videoLoadingSpinner: {
  width: '30px',
  height: '30px',
  border: '3px solid rgba(255,255,255,.2)',
  borderTopColor: '#60a5fa',
  borderRadius: '50%',
  animation: 'gd301Spin 0.85s linear infinite'
},
videoLoadingTitle: { fontSize: '15px', fontWeight: 750 },
videoLoadingText: { fontSize: '12px', color: '#bfdbfe' },
videoLoadingHint: { fontSize: '11px', color: '#9ca3af' },
videoRecoveryBadge: {
  position: 'absolute',
  left: '50%',
  bottom: '16px',
  transform: 'translateX(-50%)',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 12px',
  borderRadius: '999px',
  background: 'rgba(6,10,17,.78)',
  color: '#fff',
  fontSize: '12px',
  fontWeight: 650,
  pointerEvents: 'none',
  backdropFilter: 'blur(6px)'
},
videoRecoverySpinner: {
  width: '14px',
  height: '14px',
  border: '2px solid rgba(255,255,255,.25)',
  borderTopColor: '#fff',
  borderRadius: '50%',
  animation: 'gd301Spin 0.85s linear infinite'
},
video: {
  display: 'block',
  width: '100%',
  aspectRatio: '16 / 9',
  borderRadius: '12px',
  background: '#000',
  objectFit: 'contain'
},

videoInfo: {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '10px',
  padding: '10px 4px 2px',
  color: '#fff',
  fontSize: '12px'
},
cameraSelector: {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '8px',
  marginBottom: '10px'
},

cameraButton: {
  padding: '10px 12px',
  borderRadius: '12px',
  border: '1px solid rgba(255,255,255,0.25)',
  background: 'rgba(255,255,255,0.10)',
  color: '#fff',
  fontSize: '12px',
  fontWeight: 850,
  cursor: 'pointer'
},

cameraButtonActive: {
  background: '#2563eb',
  border: '1px solid #60a5fa'
}
};

export default NewModulePage;